module.exports = __webpack_public_path__ + "static/media/dontmakemethink.029a2c70.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/finals/books/dontmakemethink.jpg
// module id = 300
// module chunks = 0